<div class="modal-header">
  <h4 class="modal-title">Document saved</h4>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <p>The document has been successfully saved as PDF.</p>
  <div class="d-flex align-items-stretch column-gap-6">
    <a id="downloadLink" class="btn btn-primary">Download</a>
    <button [disabled]="!portalAvailable" class="btn btn-primary" (click)="onSendToPortalClicked()">
      Send to client
    </button>
  </div>
</div>
